export const strings = {
  idea_validator_tab: "Idea Validator",
  market_insights_tab: "Market Insights",
  pitch_deck_analyzer_tab: "Pitch Deck Analyzer",
  home_tab: "Home",
  learn_more_tab: "Learn More",
  home_title: "AI Tools for Your Startup Journey",
  home_text:
    "Explore our AI assistants to validate, analyze, and optimize your startup ideas",
  no_data_will_be_saved:
    "No information, analysis, or files will be stored or saved anywhere. All of the information is preview only.",
  home_select_tool: "Select an AI tool",
  idea_validator_title: "Idea Validator",
  idea_validator_text:
    "Describe your startup idea in detail. What problem does it solve? Who is your target audience? What makes your idea unique?",
  idea_validator_input_placeholder:
    "Type your startup idea description here...",
  helpful_text: "Helpful",
  not_helpful_text: "Not Helpful",
  market_insights_title: "Market Insights",
  market_insights_text:
    "Provide a brief description of your startup idea. What problem does it address? Who is your target audience? What aspects make your idea stand out?",
  pitch_deck_analyzer_title: "Pitch Deck Analyzer",
  pitch_deck_analyzer_text:
    "Upload your pitch deck and receive a detailed analysis. We'll assess key elements such as value proposition, market opportunity analysis, and completeness of your pitch deck. Get feedback and recommendations for improvement to enhance your pitch presentation",
  upload_pitch_deck_text: "Upload Pitch Deck",
  drag_and_drop_text: "Or drag-and-drop",
  analyze_text: "Analyze",
  scanning_data_text: "Scanning the data...",
  generating_answer_text: "Generating answers for you...",
  info_title: "AI Tools for Your Startup Journey",
  info_text:
    "Explore our AI assistants to validate, analyze, and optimize your startup ideas",
  info_content_title: "Learn more about Startup AI Kit",
  info_content_subtitle_one: "What is StartUp AI Kit?",
  info_content_text_one:
    "The Startup AI Kit is a comprehensive toolkit tailored to the needs of entrepreneurs, providing a suite of AI-powered tools and resources to support various stages of startup development. From ideation to scaling, the Startup AI Kit empowers founders with the knowledge, insights, and guidance needed to navigate the complexities of entrepreneurship and drive success in today's competitive landscape.",
  info_content_subtitle_two: "What is Idea Validator?",
  info_content_text_two:
    "The Idea Validator tool is designed to help entrepreneurs assess the feasibility and potential of their startup ideas. By inputting key details about their concept, such as target market, value proposition, and competitive landscape, users receive valuable feedback and validation on the viability of their idea. The tool analyzes various factors, including market demand, competition, and differentiation, to provide actionable insights and recommendations for refining and validating the startup concept.",
  info_content_subtitle_three: "What is Market Insights?",
  info_content_text_three:
    "The Market Insights tool provides entrepreneurs with comprehensive market research and analysis to better understand their target market and industry landscape. Users can access valuable data, trends, and consumer insights relevant to their business niche, enabling informed decision-making and strategic planning. From demographic profiles to market size and growth projections, this tool equips entrepreneurs with the knowledge needed to identify opportunities, assess risks, and position their startup for success in the marketplace.",
  info_content_subtitle_four: "What is Pitch Deck Analyzer?",
  info_content_text_four:
    "The Pitch Deck Analyzer tool empowers entrepreneurs to create compelling and effective pitch decks for fundraising and investor presentations. Users can upload their pitch deck presentations, and the tool provides detailed feedback and suggestions for improvement based on key criteria such as clarity, content, design, and storytelling. From refining the value proposition to enhancing visual appeal and addressing potential investor concerns, this tool helps entrepreneurs craft persuasive pitch decks that captivate investors and secure funding for their startup ventures.",
  info_content_subtitle_five: "Is my data safe with StartUp AI Kit?",
  info_content_text_five:
    "Yes, your data is safe with Startup AI Kit.  We operate under a strict policy of non-retention, ensuring that any data inputted or generated by users is not stored within our systems. Your privacy and security are our top priorities, and we are committed to providing a secure and confidential environment for all users to explore and utilize our tools with peace of mind.",
  loader_text_one: "While we scan the data read these..",
  loader_text_two:
    "“The way to get started is to quit talking and begin doing.” - Walt Disney, co-founder of The Walt Disney Company",
  loader_text_three:
    "“Your most unhappy customers are your greatest source of learning.” - Bill Gates, co-founder of Microsoft",
  loader_text_four:
    "“It's hard to beat a person who never gives up.” - Babe Ruth, baseball player",
  loader_text_five:
    "“The best time to plant a tree was 20 years ago. The second best time is now.” - Chinese Proverb",
  loader_text_six:
    "”Don't worry about failure; you only have to be right once.” - Drew Houston, co-founder and CEO of Dropbox",
  loader_text_seven:
    "“It's not about ideas. It's about making ideas happen.” - Scott Belsky, co-founder of Behance",
  loader_text_eight:
    "“You miss 100% of the shots you don't take.” - Wayne Gretzky, hockey player",
  loader_text_nine:
    "“The secret of getting ahead is getting started.” - Mark Twain, writer and humorist",
  loader_text_ten:
    "“Fail often so you can succeed sooner.” - Tom Kelley, IDEO partner",
  loader_text_eleven:
    "“We are what we repeatedly do. Excellence, then, is not an act, but a habit.” - Aristotle",
  loader_text_twelve:
    "“Building a mission and building a business go hand in hand.” - Mark Zuckerberg, co-founder and CEO of Facebook",
  loader_text_thirteen:
    "“Ideas are commodity. Execution of them is not.” - Michael Dell, Founder and CEO of Dell Technologies",
  loader_text_fourteen:
    "“Act. Learn. Repeat.” - Eric Ries, Entrepreneur and Author of “The Lean Startup”",
  loader_text_fifteen:
    "“Focus on the journey, not the destination.” - Greg Anderson, Author",
  loader_text_sixteen:
    "“Do one thing every day that scares you.” - Eleanor Roosevelt, Former First Lady of the United States",
  no_response_text: "No response generated. Please try again.",
  idea_validator_type: "idea-validator",
  market_insights_type: "market-insights",
  pitch_deck_analyzer_type: "pitch-deck-analyzer",
  file_format_error:
    "Please select one of the following formats: .doc, .docx, .pdf, .pptx, .txt",
  rate_limit_error:
    "You've exceeded the request limit. Please try again later.",
  file_too_big: "Maxium file size is 100MB",
  rate_limit_exceeded: "Rate limit exceeded",
  ask_again: "Ask something else",
  supported_files_text: "Supported files: .doc, .docx, .pdf, .pptx, .txt.",
  facebook_link: "https://www.facebook.com/ScaleUPSarajevo/",
  linkedin_link: "https://www.linkedin.com/company/scaleup-ba/mycompany/",
  instagram_link: "https://www.instagram.com/scaleup.ba/?hl=en",
  medium_link: "https://medium.com/scaleuptech",
  footer_title_one: "ScaleUp",
  footer_title_two: "Quick Links",
  footer_title_three: "Contact",
  footer_scaleup_text_one: "A forward-thinking tech partner.",
  footer_scaleup_text_two: "Join our community",
  footer_contact_text_one: "Radenka Abazovica 2A, Sarajevo",
  footer_contact_text_two: "Email: info@scaleup.ba",
  footer_copyright: "Ⓒ ScaleUp",
  footer_text_one: "Manifesto",
  footer_text_two: "About us",
  footer_text_three: "Offerings",
  footer_text_four: "Case Studies",
  footer_text_five: "Team",
  footer_text_six: "Blog",
  footer_text_seven: "Careers",
};
